// Required JS from local files
import { dfmAlert } from "./dfm5";

$(document).ready(function(){

   if (preloadState.registering) {
      dfmAlert("In order to join this class, you will need to move to the school this class is in. After this is done, you can use the link your teacher provided again.");
   }

   $("#school").dfmSchoolSelector({callback: function(school){
      $("input[name=newsid]").val(school.sid);
   }});

   $("#change-button").click(function(){
      if(!$("input[name=newsid]").val()) {
         dfmAlert("You haven't specified a new school.");
         return false;
      }
      if(!$("#newemail").val()) {
         dfmAlert("You haven't specified an email address.");
         return false;
      }
      var data = {newsid: Number($("input[name=newsid]").val()), newemail: $("#newemail").val()};
      var url = "/api/user/schoolchangerequest";
      console.log(url+" "+JSON.stringify(data));
      $.ajax({
         url: url,
         type: "PUT",
         contentType:false,
         processData: false,
         data: JSON.stringify(data),
         cache: false,
         success: function(data, textStatus, jqXHR){
            if(data.instantApprove)dfmAlert("As your email address matched the domain name for your school, we've instantly done the switch for you. <a href='/dashboard'>Click here</a> to go to your dashboard.");
            else dfmAlert("We've received your request, and you'll receive an email when the school change has either been approved or rejected.");
            $("#change-button").prop('disabled', true);
         },
         error: function(jqXHR, textStatus, errorThrown){
            const message = JSON.parse(jqXHR.responseText).message;
            if (message === "SCHOOL_REQUIRES_SSO") {
               dfmAlert("The new school requires you to link your account with a Google or Microsoft account, rather than using a password.  You must do so from <a href='https://www.drfrost.org/settings/user/account'>the account page</a> before submitting this change request.")
            }
            else {
               dfmAlert("There was an error: <br><br><strong>" + jqXHR.responseText + "</strong>");
            }
         }
      });

   });
});
